// extracted by mini-css-extract-plugin
export default {"wrapper":"xU-z","availablePromoMessagesLabel":"yU-z","promoMessageList":"zU-z","promoMessage":"AU-z","appliedPromoMessage":"BU-z","promoMessageAmount":"CU-z"};